export default __webpack_public_path__ + "static/media/ico_link_settings.c0dc6d15.svg";